import { record } from '@iwentsourcing/core/typing/record.js';
import { string } from '@iwentsourcing/core/typing/string.js';

export const StreamArgs = record(string(), string());
